import { Dialog } from "primereact/dialog";
import { useEffect, useState, useMemo } from "react";
import { carregaQuebradas } from "../services/requests/getChargesInfo";
import { formatCurrency } from "../utils/FormatCurrency";
import { addHours, format } from "date-fns";
import { usePrivate } from "../contexts/PrivateInfoContext";
import { useAuth } from "../contexts/AuthInfoContext";
import NotificacaoDialog from "./NotificacaoDialog";

function DetalhesDialog({ infoCobrancaDetalhe, close }) {
  //const {provider_id} = useAuth()
  const { providerCREF, notificacoes } = usePrivate();
  const [mostraQuebradaDialog, setMostraQuebradaDialog] = useState(false);
  const [mostraCobrancaPassadaDialog, setMostraCobrancaPassadaDialog] = useState(false);
  const [cobrancaQuebradaGeral, setCobrancaQuebradaGeral] = useState([]);
  const [cobrancaQuebradaDetalhes, setCobrancaQuebradaDetalhes] = useState([]);
  const [cobrancaQuebradaBoletos, setCobrancaQuebradaBoletos] = useState([]);
  const [mostrarNotificacaoDialog, setMostrarNotificacaoDialog] = useState(false);

  const notificacoesDaCobranca = useMemo(() => {
    return Array.isArray(notificacoes)
      ? notificacoes.filter((n) => n && n.cobranca_id === infoCobrancaDetalhe.cobranca_id)
      : [];
  }, [notificacoes, infoCobrancaDetalhe.cobranca_id]);

  useEffect(() => {
    const controller = new AbortController();

    async function fetchQuebradas() {
      const quebradasDetalhe = await carregaQuebradas(infoCobrancaDetalhe.cobranca_id, controller.signal);

      const contemTotais = quebradasDetalhe[0];
      const nContemTotais = quebradasDetalhe.slice(1);
      const checkBoletos = quebradasDetalhe.length > 0 ? quebradasDetalhe[0].boletos : [];

      // console.log('Geral', contemTotais)
      // console.log('Descrição', nContemTotais)
      // console.log('Boletos', checkBoletos)
      // console.log(quebradasDetalhe);
      setCobrancaQuebradaGeral(contemTotais);
      setCobrancaQuebradaDetalhes(nContemTotais);
      setCobrancaQuebradaBoletos(checkBoletos);
    }
    fetchQuebradas();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <>
      <Dialog
        visible
        className="boletosDialog text-center"
        header="Detalhes da Cobrança"
        onHide={() => close()}
        style={{
          maxWidth: window.innerWidth > 760 ? "30vw" : "100vw",
          textAlign: "center",
          // borderRadius: '30px',
          // padding: '10px'
        }}
      >
        <div className="font-lato-bold" style={{ textAlign: "-webkit-center" }}>
          {/* {infoCobrancaDetalhe && console.log("BBBBBBBBBBBBBBBBBBBB", infoCobrancaDetalhe)} */}
          {!infoCobrancaDetalhe.disponivel_parcial && (
            <h6 className="text-red-500">
              Esta cobrança foi adicionada antes da negociação parcial, portanto está indisponível para negociação até
              que seja feito o pagamento total da negociação mais recente
            </h6>
          )}
          {infoCobrancaDetalhe.protesto_status === "ENVIADO" && (
            <h6 className="text-red-500">
              Esta cobrança foi protestada, portanto está indisponível para negociação parcial, para negociar essa
              cobrança escolha a negociação total
            </h6>
          )}
          <div className="text-center p-6">
            <h6 className="text-slate-500">DIAS DESDE O VENCIMENTO</h6>
            <h5>{infoCobrancaDetalhe.dias}</h5>
            <h6 className="text-slate-500">VALOR ORIGINAL</h6>
            <h5>
              {formatCurrency(
                providerCREF
                  ? Number(infoCobrancaDetalhe.valor_original) + Number(infoCobrancaDetalhe.valor_fee_protesto)
                  : infoCobrancaDetalhe.valor_original
              )}
            </h5>
            {infoCobrancaDetalhe.valor_juros > 0 && (
              <>
                <h6 className="text-slate-500">VALOR DO JUROS ({infoCobrancaDetalhe.juros} % AO MÊS)</h6>
                <h5>{formatCurrency(infoCobrancaDetalhe.valor_juros)}</h5>
              </>
            )}
            {infoCobrancaDetalhe.valor_multa > 0 && (
              <>
                <h6 className="text-slate-500">VALOR DA MULTA ({infoCobrancaDetalhe.multa}%) </h6>
                <h5>{formatCurrency(infoCobrancaDetalhe.valor_multa)}</h5>
              </>
            )}
            {infoCobrancaDetalhe.valor_indice > 0 && (
              <>
                <h6 className="text-slate-500">
                  CORREÇÃO {infoCobrancaDetalhe.pcc_tipo_correcao} ({infoCobrancaDetalhe.indice}){" "}
                </h6>
                <h5>{formatCurrency(infoCobrancaDetalhe.valor_indice)}</h5>
              </>
            )}
            {!providerCREF && (
              <>
                <h6 className="text-slate-500">SERVIÇOS</h6>
                <h5>
                  {infoCobrancaDetalhe.tipo_cobranca_fee !== "credor" &&
                  infoCobrancaDetalhe.tipo_cobranca_fee !== "nenhum"
                    ? infoCobrancaDetalhe.negociacao_quebrada_id !== null
                      ? formatCurrency(
                          infoCobrancaDetalhe.valor_pagamento_com_desconto -
                            infoCobrancaDetalhe.valor_juros -
                            infoCobrancaDetalhe.valor_multa -
                            infoCobrancaDetalhe.valor_original
                        )
                      : formatCurrency(infoCobrancaDetalhe.valor_fee_protesto)
                    : "-"}
                </h5>
              </>
            )}
            {/* {providerCREF && infoCobrancaDetalhe.detalhes.protesto_status === 'ENVIADO' &&
                        <>
                        <h6 className="text-slate-500">TAXA DE ENVIO ELETRÔNICO</h6>
                        <h5>R$ 14,90</h5>
                        </>
                        } */}
            {infoCobrancaDetalhe.protesto_status === "ENVIADO" &&
              Number(infoCobrancaDetalhe.protesto_taxa_envio) > 0 && (
                <>
                  <h6 className="text-slate-500">TAXA DE ENVIO ELETRÔNICO</h6>
                  <h5>{formatCurrency(infoCobrancaDetalhe.protesto_taxa_envio)}</h5>
                </>
              )}
            {Number(infoCobrancaDetalhe.baixa_manual) > 0 && (
              <>
                <h6 className="text-slate-500">ABATIMENTOS</h6>
                <h5>{formatCurrency(infoCobrancaDetalhe.baixa_manual)}</h5>
              </>
            )}
            <h5 className="text-slate-500">VALOR CORRIGIDO</h5>
            <h4>{formatCurrency(infoCobrancaDetalhe.valor_pagamento_sem_desconto)}</h4>
          </div>
          {infoCobrancaDetalhe.negociacao_quebrada_id !== null && (
            <div className="flex justify-center w-full">
              <button
                className="hover:cursor-pointer bg-[#034551] border-white
                                flex justify-center self-center py-1 w-[80%] text-center"
                onClick={() => {
                  setMostraQuebradaDialog(true);
                }}
                style={{ borderRadius: 15 }}
              >
                <div className="flex text-base text-yellow-50">
                  {/* <i className="pi pi-exclamation-triangle mr-3" style={{ 'fontSize': '1.4em' }}></i> */}
                  <b className="">Negociação Passada</b>
                </div>
              </button>
            </div>
          )}
          {notificacoesDaCobranca.length > 0 && (
            <div className="flex justify-center w-full mt-2">
              <button
                className="hover:cursor-pointer bg-[#034551] border-white flex justify-center self-center py-1 w-[80%] text-center"
                onClick={() => setMostrarNotificacaoDialog(true)}
                style={{ borderRadius: 15 }}
              >
                <div className="flex text-base text-yellow-50">
                  <b className="">Visualizar notificação</b>
                </div>
              </button>
            </div>
          )}
        </div>

        {mostraQuebradaDialog && (
          <Dialog
            visible
            className="boletosDialog text-center"
            header="Negociação Passada"
            onHide={() => setMostraQuebradaDialog(false)}
          >
            <div>
              <h6>Está cobrança foi negociada anteriormente sem ser concluida.</h6>
              <div className="grid grid-cols-2 gap-4 place-content-evenly text-center py-2">
                <div className="grid grid-cols-1 place-content-start gap-2 text-center py-5">
                  <div
                    className="hover:cursor-pointer flex w-full bg-green-300 text-black"
                    style={{ background: "hsl(150, 100%, 20%,0.2)" }}
                    onClick={() => {
                      setMostraCobrancaPassadaDialog(true);
                    }}
                  >
                    <div className="w-[100%] py-2">
                      <h6 className="">
                        <b>Valor Original</b>
                      </h6>
                      <h5 className="">{formatCurrency(cobrancaQuebradaGeral.v_negociacao_quebrada_valor_divida)}</h5>
                    </div>
                    <div className="font-lato-bold justify-center self-center text-black mr-2" style={{}}>
                      <p
                        className="font-semibold text-lg px-3"
                        style={{
                          fontFamily: "serif",
                          backgroundColor: "#FFB107",
                          borderRadius: 30,
                          color: "white",
                        }}
                      >
                        i
                      </p>
                    </div>
                  </div>
                  <div className="bg-green-300 text-black py-2" style={{ background: "hsl(150, 100%, 20%,0.2)" }}>
                    <h6 className="">
                      <b>Valor Pago</b>
                    </h6>
                    <h5 className="">{formatCurrency(cobrancaQuebradaGeral.v_negociacao_quebrada_valor_pago)}</h5>
                  </div>
                  <div className="bg-green-300 text-black py-2" style={{ background: "hsl(150, 100%, 20%,0.2)" }}>
                    <h6 className="">
                      <b>Valor Faltando</b>
                    </h6>
                    <h5 className="">{formatCurrency(cobrancaQuebradaGeral.v_negociacao_quebrada_valor_saldo)}</h5>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-4 place-content-evenly text-center py-2">
                  {cobrancaQuebradaBoletos.map((item, index) => (
                    <div key={index} className="text-black">
                      {item.boleto_status === "true" ? (
                        <div
                          className="flex flex-row justify-center gap-5"
                          style={{ background: "hsl(140, 50%, 50%,0.8)" }}
                        >
                          <div>
                            <h5>Boleto</h5>
                            <h5>{index + 1}</h5>
                          </div>
                          <div>
                            <h5>Pago</h5>
                            <h5>{formatCurrency(item.boleto_valor)}</h5>
                          </div>
                        </div>
                      ) : (
                        <div className="grid grid-flow-row" style={{ background: "hsl(355, 100%, 50%,0.5)" }}>
                          <div className="flex flex-row justify-center gap-5">
                            <div>
                              <h5>Boleto</h5>
                              <h5>{index + 1}</h5>
                            </div>
                            <div>
                              <h5>Não Pago</h5>
                              <h5>{formatCurrency(item.boleto_valor)}</h5>
                            </div>
                          </div>
                          <div className="flex justify-around font-semibold">
                            <h6>Vencimento</h6>
                            <h6>{format(addHours(new Date(item.cobranca_data_vencimento), 3), "dd/MM/yyyy")}</h6>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Dialog>
        )}

        {mostraCobrancaPassadaDialog && (
          <Dialog
            visible
            className="text-center"
            header="Detalhes da cobrança Passada"
            onHide={() => setMostraCobrancaPassadaDialog(false)}
            style={{
              heigth: window.innerHeight > 900 ? "50vh" : "90vh",
              width: window.innerWidth > 900 ? "40vw" : "100vw",
              maxWidth: "100vw",
            }}
          >
            <div className="grid grid-cols-auto gap-2 text-center py-2">
              <div className="flex flex-row justify-between font-bold">
                <div className="w-[70%] text-left">
                  <h5>Descrição Da Cobrança</h5>
                </div>
                <div className="w-[30%]">
                  <h6>Valor</h6>
                </div>
              </div>
              {cobrancaQuebradaDetalhes.map((item, index) => (
                <div
                  key={index}
                  className="flex w-full h-full font-medium items-center"
                  style={{ background: "hsl(180, 95%, 30%,0.1)" }}
                >
                  <div className="grid items-center text-left w-[70%] pl-2">
                    <p className="text-base capitalize">{item.v_cobranca_descricao}</p>
                  </div>
                  <div className="grid items-center w-[30%] h-full">
                    <h6>{formatCurrency(item.v_valor_para_pagamento)}</h6>
                  </div>
                </div>
              ))}
            </div>
          </Dialog>
        )}
        {mostrarNotificacaoDialog && (
          <NotificacaoDialog
            close={() => setMostrarNotificacaoDialog(false)}
            notificacoes={notificacoesDaCobranca}
            showControls={false}
          />
        )}
      </Dialog>
    </>
  );
}

export default DetalhesDialog;
